<template>
  <div id="data-list-companies" class="data-list-container">
    <vs-table ref="table" responsive pagination :max-items="itemsPerPage" search :data="originList">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
          <!-- ITEMS PER PAGE -->
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
            <div
              class="
                p-4
                border border-solid
                d-theme-border-grey-light
                rounded-full
                d-theme-dark-bg
                cursor-pointer
                flex
                items-center
                justify-between
                font-medium
              "
            >
              <span class="mr-2">{{ minItemsPerPage }} - {{ currentItemsPerPage }} of {{ queriedItems }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item @click="itemsPerPage = 4">
                <span>4</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 10">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 20">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 50">
                <span>50</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
      </div>

      <template slot="thead">
        <vs-th sort-key="sequentialID">{{$t(`COMPANIES.id`)}}</vs-th>
        <vs-th sort-key="name">{{$t(`COMPANIES.name`)}}</vs-th>
        <vs-th sort-key="expireAccount">{{$t(`COMPANIES.ExpiredTo`)}}</vs-th>
        <vs-th sort-key="status">{{$t(`COMPANIES.state`)}}</vs-th>
        <vs-th>{{$t(`COMPANIES.accions`)}}</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-category">{{ tr.sequentialID }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.name }}</p>
            </vs-td>

            <vs-td>
              <span class="p-1 rounded font-bold" :class="stateDate(data[indextr].expireAccount)">
                {{ data[indextr].expireAccount | formatDate }}
              </span>
            </vs-td>

            <vs-td>
              <vs-progress :percent="100" :color="tr.status | getPopularityColor" class="shadow-md" />
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon
                class="ml-2"
                icon="EditIcon"
                svgClasses="w-5 h-5 hover:text-success stroke-current"
                @click.stop="$emit('sendKey', tr.key)"
              />
              <feather-icon
                class="ml-2"
                icon="InfoIcon"
                svgClasses="w-5 h-5 hover:text-success stroke-current"
                @click.stop="infoData(tr)"
              />

              <feather-icon
                class="ml-2"
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                @click.stop="deleteData(tr)"
              />
            </vs-td>

            <template class="expand-user" slot="expand">
              <div class="con-expand-users w-full">
                <div class="con-btns-user flex items-center justify-between">
                  <div class="con-userx flex items-center justify-start">
                    <!-- <vs-avatar
                      :badge="tr.id"
                      size="45px"
                      :src="`https://randomuser.me/api/portraits/women/${indextr}.jpg`"
                    /> -->
                    <b>PERSONA CONTACTO: </b> &nbsp; <span> {{ tr.contactPerson }}</span>
                  </div>
                </div>
                <vs-list>
                  <!-- <vs-list-item icon-pack="feather" icon="icon-people" :title="tr.contactPerson"></vs-list-item> -->
                  <vs-list-item icon-pack="feather" icon="icon-mail" :title="tr.email"></vs-list-item>
                  <vs-list-item icon-pack="feather" icon="icon-phone" :title="tr.cellPhone"></vs-list-item>
                </vs-list>
              </div>
            </template>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import * as Companies from "./Companies";
import moment from "moment";

export default {
  data() {
    return {
      activeForm: {},
      activePrompt: false,
      selectedFormVersion: 1,

      activePopup: false,
      listGroups: [],

      recordId: null,
      originList: [],
      itemsPerPage: 7,
      isMounted: false
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        // return this.$refs.table.currentx;
        return true;
      }
      return 0;
    },
    queriedItems() {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.originList.length;
    },
    minItemsPerPage() {
      return this.currentPage * this.itemsPerPage - (this.itemsPerPage - 1);
    },
    currentItemsPerPage() {
      return this.originList.length - this.currentPage * this.itemsPerPage > 0
        ? this.currentPage * this.itemsPerPage
        : this.originList.length;
    }
  },
  filters: {
    getPopularityColor(status) {
      switch (status) {
        case "Active":
          return "primary";
          break;
        case "Inactive":
          return "warning";
          break;
        case "Blocked":
          return "danger";
          break;
        case "Banned":
          return "danger";
          break;
        case "Deleted":
          return "danger";
          break;
        default:
          return "warning";
          break;
      }
    },
    formatDate(date) {
      return moment(date).format("DD MMM YYYY");
    }
  },
  methods: {
    async getAllCompanies() {
      this.$vs.loading({ type: "sound" });

      try {
        const result = await Companies.getAllCompanies();
        this.originList = result.filter(company => company.status !== "Deleted");
      } catch (error) {
        this.$vs.notify({
          title: this.$t(`COMPANIES.companies`),
          text: `${this.$t(`COMPANIES.errorQueryCompanies`)}(${error.message})`,
          color: "warning",
          icon: "error",
          time: 6000
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    deleteData(data) {
      this.recordId = data.key;

      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `${this.$t(`COMPANIES.titleAlert`)} ${data.name}`,
        text: this.$t(`COMPANIES.messageAlert`),
        acceptText: this.$t(`COMPANIES.accept`),
        cancelText: this.$t(`COMPANIES.cancel`),
        accept: this.deleteItem
      });
    },

    async deleteItem() {
      this.$vs.loading({ type: "sound" });

      try {
        await Companies.deleteCompany(this.recordId);
        await this.getAllCompanies();
      } catch (error) {
        console.log("deleteItem Error:", error);

        this.$vs.notify({
          title: this.$t(`COMPANIES.deleteCompany`),
          text: this.$t(`COMPANIES.errorDeleteCompany`),
          color: "warning",
          icon: "error",
          time: 6000
        });
      } finally {
        this.recordId = null;
        this.$vs.loading.close();
      }
    },

    infoData(data) {
      this.$vs.notify({
        title: this.$t(`COMPANIES.companies`),
        text: this.$t(`COMPANIES.actionDisabled`),
        color: "warning",
        icon: "error",
        time: 4500
      });
    },
    stateDate(date) {
      const today = moment();
      const expired = moment(date);
      const diferent = expired.diff(today, "days");

      if (diferent <= 0) return "text-danger";
      if (diferent <= 4 && diferent >= 0) return "text-warning";
      return "text-success";
    }
  },
  mounted() {
    this.isMounted = true;
    this.getAllCompanies();
  }
};
</script>

<style lang="scss">
#data-list-companies {
  @import "@/assets/css/_themeTable.scss";
}
</style>
